export default __webpack_public_path__ + "static/media/inforIcon.a3061c10.svg";